import { cn } from "@discovery/classnames";
import { useState } from "@discovery/common-dplus/lib/hooks";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import { pushFavoriteOrWatchListEvents } from "@discovery/common-dplus/lib/adobe";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Favorite from "@discovery/sonic-api-ng/lib/api/users/favorites";
import { useUser } from "../../../utils/hooks/useUser";
import { navigateTo } from "../../../utils/common";
import { shareHandler, SHARE_TYPE } from "../../../utils/share";
import { HeaderVariants, Tags, Typography } from "../../atoms/typography";
import Strings from "../../../utils/hardcoded.json";
import * as styles from "./styles.css";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { setAuthRedirectUrl } from "../../../utils/authUrl";
import { blueshiftFavorite } from "@discovery/common-dplus/lib/blueshift";
export const KebabMenu = ({ closekebabMenu, type, cardData, read, webAuthRedirectionUrl, anonymous, setCardData, isFavPage, isWatchlaterPage, removeFromfavorites, toastHandler, vType, }) => {
    const { userId } = useUser();
    const videoType = cardData && M.fromMaybe(cardData.videoType, "");
    const { isFavoriteM = M.empty() } = cardData;
    const isFavorite = isFavoriteM && M.fromMaybe(isFavoriteM, false);
    const [isFavId, toggleFav] = useState(isFavorite);
    const tempFavId = localStorage.getItem("tempFavId");
    const likeId = localStorage.getItem("favId");
    const favId = likeId ? likeId : tempFavId;
    const isFav = favId === cardData.id && !anonymous ? true : isFavId;
    const sendGenre = cardData.genre && M.fromMaybe(cardData.genre, "");
    const toggleFavourite = (id, type, isFavorite) => {
        if (!isFavorite) {
            const postRequest = Favorite.Endpoints.deleteFavorite(id, type);
            read &&
                App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                    /* handle exception here */
                    () => {
                        toastHandler(Strings.ERROR_SAVING_PREFERENCE, false);
                    };
                }, () => {
                    const setItem = () => {
                        if ((cardData.isFavoriteM = M.of(isFavorite)))
                            return cardData;
                        return;
                    };
                    const card = setItem();
                    card && setCardData && setCardData(card);
                    cardData.name ? name : "";
                    blueshiftFavorite(userId, id, "delete", videoType, cardData.title ? cardData.title : "", sendGenre ? [...sendGenre] : [""]);
                    toggleFav(!isFavorite);
                    toastHandler(isFavorite
                        ? Strings.ADD_TO_FAVOURITES
                        : Strings.REMOVE_FROM_FAVOURITES, true);
                    closekebabMenu && closekebabMenu();
                }));
        }
        else {
            const postRequest = Favorite.Endpoints.postFavorite(id, type);
            read &&
                App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                    /* handle exception here */
                    () => {
                        toastHandler(Strings.ERROR_SAVING_PREFERENCE, false);
                    };
                }, () => {
                    const setItem = () => {
                        if ((cardData.isFavoriteM = M.of(isFavorite)))
                            return cardData;
                        return;
                    };
                    const card = setItem();
                    card && setCardData && setCardData(card);
                    toggleFav(!isFavorite);
                    blueshiftFavorite(userId, id, "add", videoType, cardData.title ? cardData.title : "", sendGenre ? [...sendGenre] : [""]);
                    toastHandler(isFavorite
                        ? Strings.ADD_TO_FAVOURITES
                        : Strings.REMOVE_FROM_FAVOURITES, true);
                    closekebabMenu && closekebabMenu();
                }));
        }
    };
    const removeFromFavorites = (id, videoType) => {
        const postRequest = Favorite.Endpoints.deleteFavorite(id, `${videoType}`);
        read &&
            App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
            }, () => {
                removeFromfavorites && removeFromfavorites(id);
                pushFavoriteOrWatchListEvents("remove favorites", "remove favorites", window.location.href, window.location.origin + cardData.route);
                closekebabMenu && closekebabMenu();
            }));
    };
    const favouriteClickHandler = (isFavorite, id) => {
        const authUrl = webAuthRedirectionUrl + "/login";
        const videoType = type === "show" ? type : "video";
        if (anonymous) {
            id && localStorage.setItem("favId", id);
            localStorage.setItem("favType", videoType);
            id && localStorage.setItem("tempFavId", id);
            const authRedirect = setAuthRedirectUrl(window.location.pathname);
            navigateTo(`${authUrl}?returnUrl=${authRedirect}`);
        }
        else if (id && read) {
            if (isFavPage && !isFavorite) {
                removeFromFavorites(id, videoType);
            }
            else {
                localStorage.removeItem("tempFavId");
                toggleFavourite(id, videoType, isFavorite);
            }
        }
    };
    const kebabMenuItemHandlerVideos = (itemId, name, route, videoId, descriptionM, image) => {
        const shareURL = config.shareBaseURL + route;
        switch (itemId) {
            case "UNLIKE":
                return favouriteClickHandler(false, videoId);
            case "LIKE":
                return favouriteClickHandler(true, videoId);
            case "SHARE":
                return shareHandler(SHARE_TYPE.SHARE, image, descriptionM, name, shareURL);
        }
    };
    const getKebabMenuItems = () => {
        const menuItems = [
            {
                label: !isFav
                    ? Strings.ADD_TO_FAVOURITE
                    : Strings.REMOVE_FROM_FAVOURITE,
                id: !isFav ? "LIKE" : "UNLIKE",
            },
            {
                label: Strings.SHARE,
                id: "SHARE",
            },
        ];
        return menuItems;
    };
    const favouritesKebabeMenuItems = () => {
        const menuItems = [
            {
                label: !isFav
                    ? Strings.ADD_TO_FAVOURITE
                    : Strings.REMOVE_FROM_FAVOURITE,
                id: !isFav ? "LIKE" : "UNLIKE",
            },
            {
                label: Strings.SHARE,
                id: "SHARE",
            },
        ];
        return menuItems;
    };
    const LiveChannelMenuItems = () => {
        const menuItems = [
            {
                label: Strings.SHARE,
                id: "SHARE",
            },
        ];
        return menuItems;
    };
    const kebabMenuItems = isWatchlaterPage
        ? favouritesKebabeMenuItems()
        : isFavPage
            ? favouritesKebabeMenuItems()
            : vType !== "LIVE"
                ? getKebabMenuItems()
                : LiveChannelMenuItems();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(styles.wrapper, {
                [styles.showWrapper]: type === "show",
            }) }, kebabMenuItems &&
            kebabMenuItems.map((item, index) => {
                return (React.createElement("div", { className: styles.onHover, onClick: () => {
                        kebabMenuItemHandlerVideos(item.id, cardData.name, cardData.route, cardData.id, cardData.descriptionM, cardData.image);
                    }, key: index },
                    React.createElement(Typography, { classNameM: M.of(styles.listItems), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, item.label))));
            }))));
};

